import { Select, styled } from '@mui/material';
import Colors from '../../constants/colors';

export const StyledSelect = styled(Select)(
    ({ theme, height, textColor, borderColor, changed }) =>
        ({
            height,
            color: changed ? theme.palette.primary.main : textColor,
            backgroundColor: changed ? Colors.ACTIVE_FILTER_BG : 'transparent',
            '& fieldset': {
                borderColor: changed ? theme.palette.primary.main : borderColor,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderWidth: '1px',
            },
            fontSize: '14px',
            'li': {
                fontSize: '14px',
            },
            '& .MuiSelect-icon': {
                fontSize: 22.286,
                color: changed ? theme.palette.primary.main : textColor,
            },
        }));